import {
  Card,
  Divider,
  Table,
  TableBody,
  TableHead,
  Dialog,
  DialogTitle,
  Typography,
  Pagination,
  Grid,
  CardContent,
  TableContainer,
  TextField,
  Button,
  Box
} from '@mui/material'
import moment from 'moment'
import { useState } from 'react'
import { StyledTableCell, StyledTableRow } from '../../../utils/ui_utils'

function PaymentHistory({
  initialValues,
  visibility,
  onClose,
  title,
  onPageChange,
  pagecount,
  page
}) {
  const [goToPageInput, setGoToPageInput] = useState('')

  if (initialValues == undefined) initialValues = []

  const handlePageChange = async (event, value) => {
    onPageChange(value)
  }

  const handleGoToPageChange = (event) => {
    const value = event.target.value
    if (/^\d+$/.test(value) || value === '') {
      setGoToPageInput(value)
    }
  }

  const handleGoToPageSubmit = () => {
    const pageNum = parseInt(goToPageInput, 10)
    if (pageNum >= 1 && pageNum <= pagecount) {
      handlePageChange(null, pageNum)
      setGoToPageInput('')
    }
  }

  const handleGoToPageKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleGoToPageSubmit()
    }
  }

  return (
    <Dialog
      open={visibility}
      maxWidth="lg"
      fullWidth
      onClose={onClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        {title}
      </DialogTitle>

      <Divider />
      <Grid container spacing={1}>
        <Grid item md={10} lg={12}>
          <Card raised sx={{ borderRadius: 3 }}>
            <CardContent sx={{ flexGrow: 1 }}>
              <TableContainer component={Card}>
                <Table size="small">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell align="left">Plan Name</StyledTableCell>
                      <StyledTableCell align="left">
                        Purchase Type
                      </StyledTableCell>
                      <StyledTableCell align="left">Order Id</StyledTableCell>
                      <StyledTableCell align="left">Date</StyledTableCell>
                      <StyledTableCell align="center"># Users</StyledTableCell>
                      <StyledTableCell align="left">
                        {' '}
                        Unit Price
                      </StyledTableCell>
                      <StyledTableCell align="left"> Qty</StyledTableCell>
                      <StyledTableCell align="left"> Total Amt</StyledTableCell>

                      <StyledTableCell align="left">
                        {' '}
                        Fixed Price{' '}
                      </StyledTableCell>
                      <StyledTableCell align="left">Status</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {initialValues?.map((row) => (
                      <StyledTableRow key={row._id} hover>
                        <StyledTableCell
                          align="left"
                          component="th"
                          scope="row"
                        >
                          {row.purchased_items[0]?.plan?.name}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row.purchased_items[0]?.purchasetype?.short_name}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row?.payment_order_id}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {moment(new Date(row?.updated_date)).format(
                            'DD/MM/YYYY'
                          )}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row?.no_of_users}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {row?.purchased_items[0]?.unit_price}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {row?.purchased_items[0]?.qty}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {row?.total_amount}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {row?.purchased_items[0]?.fixed_charge}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {' '}
                          {row.status}{' '}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
            {pagecount > 1 && (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                  p: 2,
                  backgroundColor: 'grey.50',
                  borderRadius: 1
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%'
                  }}
                >
                  <Pagination
                    count={pagecount}
                    page={page}
                    color="secondary"
                    size="small"
                    boundaryCount={2}
                    siblingCount={0}
                    showFirstButton
                    showLastButton
                    onChange={handlePageChange}
                    sx={{
                      '& .MuiPaginationItem-root': {
                        transition: 'all 0.2s ease-in-out'
                      }
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 1.5,
                    backgroundColor: 'white',
                    p: 2,
                    borderRadius: 1,
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                    transition: 'box-shadow 0.2s ease-in-out',
                    '&:hover': { boxShadow: '0 2px 6px rgba(0,0,0,0.12)' }
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ color: 'text.secondary', fontWeight: 500 }}
                  >
                    Jump to
                  </Typography>
                  <TextField
                    size="small"
                    value={goToPageInput}
                    onChange={handleGoToPageChange}
                    onKeyPress={handleGoToPageKeyPress}
                    placeholder="Page"
                    sx={{
                      width: '80px',
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: 'white',
                        transition: 'all 0.2s ease-in-out',
                        '& fieldset': {
                          borderColor: 'grey.300',
                          borderWidth: '1px'
                        },
                        '&:hover fieldset': {
                          borderColor: 'secondary.main',
                          borderWidth: '1.5px'
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'secondary.main',
                          borderWidth: '2px',
                          boxShadow: '0 0 0 3px rgba(156, 39, 176, 0.1)'
                        }
                      },
                      '& .MuiOutlinedInput-input': {
                        textAlign: 'center',
                        fontWeight: 500,
                        padding: '7px 8px',
                        height: '20px',
                        lineHeight: '20px'
                      }
                    }}
                  />
                  <Typography
                    variant="body2"
                    sx={{ color: 'text.secondary', fontWeight: 400 }}
                  >
                    of {pagecount}
                  </Typography>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={handleGoToPageSubmit}
                    disabled={
                      !goToPageInput ||
                      parseInt(goToPageInput, 10) < 1 ||
                      parseInt(goToPageInput, 10) > pagecount
                    }
                    sx={{
                      textTransform: 'none',
                      fontWeight: 500,
                      px: 2,
                      py: 0.75,
                      height: '34px',
                      lineHeight: 1,
                      transition: 'all 0.2s ease-in-out',
                      '&:hover': {
                        transform: 'translateY(-1px)',
                        boxShadow: '0 4px 8px rgba(156, 39, 176, 0.3)'
                      },
                      '&:active': { transform: 'translateY(0)' }
                    }}
                  >
                    Go
                  </Button>
                </Box>
              </Box>
            )}
          </Card>
        </Grid>
      </Grid>
    </Dialog>
  )
}

export default PaymentHistory
